import React from "react";
import {
  resolveCoursePricingType,
  DEFAULT_COURSE_CURRENCY,
  type InstructorCourse,
} from "services/instructorCoursesService";

export type CoursePricingBadgeProps = {
  course: Partial<InstructorCourse>;
  isArabic: boolean;
  className?: string;
};

/**
 * Compact badge: "مجاني / Free" for free courses, "250 EGP" for paid ones.
 */
export default function CoursePricingBadge({ course, isArabic, className = "" }: CoursePricingBadgeProps) {
  const type = resolveCoursePricingType(course);

  if (type === "free") {
    return (
      <span
        className={`inline-flex items-center rounded-full bg-emerald-100 px-2 py-0.5 text-[11px] font-bold text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300 ${className}`}
      >
        {isArabic ? "مجاني" : "Free"}
      </span>
    );
  }

  const price = Number(course.price ?? 0);
  const currency = course.currency || DEFAULT_COURSE_CURRENCY;
  const amount = Number.isInteger(price) ? String(price) : price.toFixed(2);

  return (
    <span
      className={`inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-bold text-amber-700 dark:bg-amber-500/15 dark:text-amber-300 ${className}`}
    >
      {isArabic ? `${amount} ${currency}` : `${amount} ${currency}`}
    </span>
  );
}
